import styles from '../index.module.css'

import React, { Component } from 'react'

import { getAliasValue, getOriginalAliasValue } from '@disco/utils/aliases'

import type { Track, TrackAlias } from 'types/track'
import type { UserAliasSettings } from 'types/user-settings'

import Input from 'components/ui/input'

type Props = {
  index: number
  alias?: TrackAlias
  track: Track
  onChange: (
    trackId: number,
    key: string,
    value: string | null | undefined,
  ) => void
  parentAlias: UserAliasSettings
  disabled?: boolean
}
export default class TrackAliasItem extends Component<Props> {
  shouldComponentUpdate(nextProps: Props): boolean {
    // Components are being updated due to parentAlias is always changing on
    // render, can be also fixed in parent component
    return (
      nextProps.alias !== this.props.alias ||
      nextProps.track !== this.props.track
    )
  }

  _onChange: (e: any, initialValue: string | null | undefined) => void = (
    e: Record<string, any>,
    initialValue: string | null | undefined,
  ) => {
    if (e.target.value === initialValue) {
      this.props.onChange(this.props.track.id, e.target.name, null)
    } else {
      this.props.onChange(this.props.track.id, e.target.name, e.target.value)
    }
  }
  _onTitleChange: (e: React.SyntheticEvent) => void = (
    e: React.SyntheticEvent,
  ) => {
    const { parentAlias, track } = this.props
    // @ts-expect-error
    const value = getOriginalAliasValue(parentAlias, 'Title', track.name) || ''

    this._onChange(e, typeof value === 'string' ? value : value.toString())
  }
  _onArtistChange: (e: React.SyntheticEvent) => void = (
    e: React.SyntheticEvent,
  ) => {
    const { parentAlias, track } = this.props
    const value =
      // @ts-expect-error
      getOriginalAliasValue(parentAlias, 'Artist', track.artist) || ''

    this._onChange(e, typeof value === 'string' ? value : value.toString())
  }
  _onAlbumChange: (e: React.SyntheticEvent) => void = (
    e: React.SyntheticEvent,
  ) => {
    const { parentAlias, track } = this.props
    // @ts-expect-error
    const value = getOriginalAliasValue(parentAlias, 'Album', track.album) || ''

    this._onChange(e, typeof value === 'string' ? value : value.toString())
  }

  render(): React.ReactElement<'li'> {
    const { index, alias, track, parentAlias, disabled } = this.props
    const titleValue = getAliasValue(parentAlias, alias, 'Title', track.name)
    const artistValue = getAliasValue(
      parentAlias,
      alias,
      'Artist',
      track.artist,
    )
    const albumValue = getAliasValue(parentAlias, alias, 'Album', track.album)
    return (
      <li className={styles.individualTabAliasesAlias}>
        <div className={styles.individualTabAliasesHeader}>
          <div>{index}</div>
          <Input
            disabled={disabled}
            className="Table_Input"
            name="Title"
            title={track.name}
            value={titleValue || ''}
            onChange={this._onTitleChange}
          />
          <Input
            disabled={disabled}
            className="Table_Input"
            name="Artist"
            title={track.artist}
            value={artistValue || ''}
            onChange={this._onArtistChange}
          />
          <Input
            disabled={disabled}
            className="Table_Input"
            name="Album"
            title={track.album}
            value={albumValue || ''}
            onChange={this._onAlbumChange}
          />
        </div>
      </li>
    )
  }
}
